// Singleton @sympllex/api-client instance. The active session (set by SessionProvider)
// is injected as the dev session header in ENVIRONMENT=dev; swap to bearer mode once
// WorkOS browser auth lands (C1.3 follow-up). PLAN-C4.0 task-2.
import { createApiClient, type SympllexApiClient } from "@sympllex/api-client";
import type { SympllexSession } from "@sympllex/auth";
import { API_BASE } from "./env";
import { refreshSession } from "./auth";

let currentSession: SympllexSession | null = null;
export function setApiSession(s: SympllexSession | null): void { currentSession = s; }

export const api: SympllexApiClient = createApiClient({
  baseUrls: API_BASE,
  // prod: rely on the httpOnly session cookie (credentialed CORS). dev: inject the dev-session header.
  mode: import.meta.env.DEV ? "dev" : "cookie",
  getSession: () => currentSession,
  // On a 401 (expired 15-min access token) silently refresh off the 14-day session, then retry once.
  onUnauthorized: refreshSession,
});
